import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringAreaNeurology = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Neeteesh Kr. Roy.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. NEETEESH KR. ROY</h1>
                                <p>
                                    M.B.B.S., MS, MCH (NEURO)
                                    <br />
                                    Ex. S.R. LNJP New Delhi, CMC Vellore
                                    <br />
                                    7 YEARS OF EXPERIENCE
                                    <br />
                                    500 SURGERIES
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. AKHILESH KR. SINGH</h1>
                                <p>
                                    M.B.B.S., MD,
                                    <br />
                                    GENERAL MEDICINE (IMS BHU)
                                    <br />
                                    18 YEARS OF EXPERIENCE
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon ml-0"><span>+</span>Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Akhilesh Kr. Singh.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringAreaNeurology;